/*
 * @Author: wsx
 * @Date: 2022-01-09 18:04:29
 * @LastEditTime: 2022-01-24 17:58:31
 * @LastEditors: your name
 * @Description:
 */
import request from "@/utils/request.js";

// 获取部门树
export const queryOrganTre = data => {
  return request({
    url: "/api/query/organTree",
    params: data || {}
  });
};

// 获取部门树
export const queryOrganList = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/list",
    params: data || {}
  });
};
// 按ID获取部门树
export const queryOrganListId = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/list/id",
    params: data || {}
  });
};

// 获取部门树
export const queryDeptList = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/select",
    params: data || {}
  });
};

// 获取部门列表（包含人员）
export const queryOrganPersonList = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/selectAndUser",
    params: data || {}
  });
};

// // 获取部门列表（包含人员）
// export const queryOrganList = data => {
//   return request({
//     url: "/api/hz-smart-community/sys/dept/infoAndSonInfo/{deptId}",
//     params: data || {}
//   });
// };

// 添加部门
export const addOrgan = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/save",
    data: data || {},
    method: "post"
  });
};

// 更新部门信息
export const updateOrgan = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/update",
    data: data || {},
    method: "post"
  });
};

// 删除部门
export const deleteOrgan = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/delete",
    data: data || {},
    method: "post"
  });
};

// 设置负责人
export const setMainUser = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/saveMainUser",
    data: data || {},
    method: "post"
  });
};
// 获取用户列表
export const queryUser = data => {
  return request({
    url: "/api/query/user",
    params: data || {}
  });
};